export const GMAIL_BASE_URL = 'https://mail.google.com';
